import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import { teamNameService } from '../../services/teamNameService';

const TeamNameModal = ({ open, onClose, onSuccess }) => {
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      setError('チーム名を入力してください');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      const newTeam = await teamNameService.createTeamName(name.trim());
      onSuccess(newTeam);
      handleClose();
    } catch (error) {
      setError(error.message || 'チーム名の登録に失敗しました');
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!submitting) {
      setName('');
      setError('');
      onClose();
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
        }
      }}
    >
      <form onSubmit={handleSubmit}>
        <DialogTitle sx={{ pb: 1 }}>
          <Typography variant="h6" component="div" sx={{ fontWeight: 600 }}>
            チーム名登録
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>
            新しいチーム名を登録します。登録後、自動的にフォームに反映されます。
          </Typography>
          <TextField
            fullWidth
            label="チーム名"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!error}
            helperText={error || 'チーム名を入力してください（例：Team Liquid、ZETA DIVISION）'}
            disabled={submitting}
            placeholder="例：Team Liquid"
            autoFocus
            sx={{
              '& .MuiInputBase-input': {
                fontSize: '1.1rem',
                padding: '12px 14px',
              },
              '& .MuiInputLabel-root': {
                fontSize: '1rem',
              },
              '& .MuiOutlinedInput-root': {
                '&:hover fieldset': {
                  borderColor: 'primary.main',
                },
              },
            }}
            inputProps={{
              maxLength: 100,
            }}
          />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button
            onClick={handleClose}
            disabled={submitting}
            color="inherit"
          >
            キャンセル
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={submitting}
            sx={{
              background: 'linear-gradient(45deg, #3b82f6 30%, #6366f1 90%)',
              boxShadow: '0 3px 5px 2px rgba(59, 130, 246, .3)',
              position: 'relative',
              minWidth: 100,
            }}
          >
            {submitting ? (
              <>
                <CircularProgress
                  size={20}
                  sx={{
                    position: 'absolute',
                    left: '50%',
                    marginLeft: '-10px',
                    color: 'white',
                  }}
                />
                <Box sx={{ opacity: 0 }}>登録</Box>
              </>
            ) : (
              '登録'
            )}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default TeamNameModal;
